import React, { useEffect, useRef, useState } from "react";
import Breadcrumbs from "../../common/Breadcrumbs/Breadcrumbs";
import { BiFilterAlt } from "react-icons/bi";
import Popup from "../../popups/Popup/Popup";
import { useDispatch, useSelector } from "react-redux";
import {
  getUploadedUGCContentForInfluencer,
  getUploadedUGCContentForInfluencerReset,
} from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/getUploadedUGCContentForInfluencerActions";
import moment from "moment";
import { streamVideo } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/streamVideoActions";
import { MyCampaignsImg } from "../../../static/constant/imgConstants";
import { publishVideoOnYoutube } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/publishVideoOnYoutubeAction";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router";
import Footer from "../../common/Footer/Footer";
import { Oval } from "react-loader-spinner";
import { useToast } from "../../../hooks/useToast";
import { downloadContentForManualUpload } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/downloadContentForManualUploadActions";
import { downloadContentForManualUploadReset } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/downloadContentForManualUploadActions";
import { TbClockPlay } from "react-icons/tb";
import { FaCirclePlay } from "react-icons/fa6";
import { optAndSubmitContentLink } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/optAndSubmitContentLinkActions";
import { isPastDate } from "../../../utils/date";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { IoIosCloseCircle } from "react-icons/io";
import { BsCollectionPlayFill } from "react-icons/bs";

const sanitizeStatus = (input) => {
  const statusMap = {
    VIDEO_ID_LAMBDA_VERIFICATION_FAILED: "VIDEO ID VERIFICATION FAILED",
    VIDEO_ID_LAMBDA_VERIFICATION_SUCCESS: "VIDEO ID VERIFIED",
    BUDGET_RELEASED_ADMIN_VIDEO_ID_VERIFICATION_FAILED: "BUDGET_RELEASED_ADMIN_VIDEO_ID_VERIFICATION_FAILED"
  };

  const sanitized = String(input).trim().toUpperCase();
  if (statusMap.hasOwnProperty(sanitized)) {
    return statusMap[sanitized];
  }
  return input;
}

const getStatusStyle = (status) => {
  switch (status) {
    case "UGC_APPROVED":
      return "bg-[#00B69B] text-[#FFFFFF]";
    case "UGC_REJECTED":
      return "bg-[#FD5454] text-[#FFFFFF]";
    case "PUBLISHED":
      return "bg-[#0D9B50] text-[#FFFFFF]";
    default:
      return "bg-[#FCBE2D] text-[#FFFFFF]";
  }
};

// Create this component inside the ApprovedList file or as a separate component
const ContentCard = ({
  content,
  onPreview,
  onPublish,
  onSchedule,
  onReUpload,
  onSubmitVideoId,
  onDownload,
  hasFullAccess,
  platformTitle,
}) => (
  <div className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-300">
    <div className="flex flex-col space-y-3">
      {/* Campaign Name */}
      <div>
        <span className="text-[1.6rem] font-medium">{content.campaignName}</span>
      </div>

      {/* Upload Date */}
      <div className="flex items-center">
        <span className="text-[1.4rem] font-bold w-32">Upload Date:</span>
        <span className="text-[1.4rem] break-words whitespace-normal w-full">
          {moment.utc(content.uploadedAt.split("+")[0]).local().format("DD-MM-YYYY hh:mm A")}
        </span>
      </div>

      {/* Platform */}
      <div className="flex items-center">
        <span className="text-[1.4rem] font-bold w-32">Platform:</span>
        <span className="text-[1.4rem] break-words whitespace-normal w-full">
          {content?.platform === 'YOUTUBE' ? 'YouTube' : content?.platform === 'INSTAGRAM' ? 'Instagram' : (content?.platform || '-')}
        </span>
      </div>

      {/* Status */}
      <div className="flex items-center">
        <span className="text-[1.4rem] font-bold w-32">Status:</span>
        <span className={`text-[1.4rem] px-2 py-1 rounded-full break-words whitespace-normal w-full ${getStatusStyle(content.status)}`}>
          {sanitizeStatus(content.status)}
        </span>
      </div>

      {/* Reject Reason (if applicable) */}
      <div className="flex items-center">
        <span className="text-[1.4rem] font-bold w-32">Reject Reason:</span>
        <span className="text-[1.4rem]">{content.status === "UGC_REJECTED" && content.ugcRejectReason ? content.ugcRejectReason : "-"}</span>
      </div>

      {/* Content Preview Button */}
      <div className="mt-2">
        <button
          className="bg-[#FF0505CC] text-white text-center text-[1.4rem] rounded-[1.4rem] py-[0.5rem] w-full"
          onClick={() => onPreview(content)}
        >
          Preview
        </button>
      </div>

      {/* Action Buttons based on status */}
      {(content.status === "UGC_APPROVED" || content.status === "ADMIN_REJECT_VIDEO_ID") && (
        hasFullAccess ? (
          <div className="flex flex-col space-y-2 mt-2">
            <button
              className="bg-[#0D9B50] text-white text-center text-[1.4rem] rounded-[1rem] py-[0.4rem] w-full"
              onClick={() => onPublish(content)}
            >
              Publish It
            </button>
            <button
              className="bg-[#0D9B50] text-white text-center text-[1.4rem] rounded-[1rem] py-[0.4rem] w-full"
              onClick={() => onSchedule(content)}
            >
              Schedule
            </button>
          </div>
        ) : (
          <div className="flex flex-col space-y-2 mt-2">
            <button
              className="bg-[#0D9B50] text-white text-center text-[1.4rem] rounded-[1rem] py-[0.4rem] w-full"
              onClick={() => onSubmitVideoId(content)}
            >
              {content.status === "ADMIN_REJECT_VIDEO_ID" ? "Re Submit Video ID" : "Submit Video ID"}
            </button>
            <button
              className="bg-[#0D9B50] text-white text-center text-[1.4rem] rounded-[1rem] py-[0.4rem] w-full"
              onClick={() => onDownload(content)}
            >
              Download
            </button>
          </div>
        )
      )}

      {
      (content.status== "UGC_REJECTED") && (
        <div className="mt-2">
          <button
            className="bg-[#0D9B50] text-white text-center text-[1.4rem] rounded-[1rem] py-[0.5rem] w-full"
            onClick={() => onReUpload(content)}
          >
            Re Upload
          </button>
        </div>
      )}
    </div>
  </div>
);

const ApprovedList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const Toast = useToast();

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupType, setPopupType] = useState(null);
  const [successPopupOpen, setSuccessPopupOpen] = useState(false);
  const [
    getUploadedUGCContentForInfluencerData,
    setGetUploadedUGCContentForInfluencerData,
  ] = useState();
  const [publishTitle, setPublishTitle] = useState();
  const [publishDescription, setPublishDescription] = useState();
  const [scheduleTime, setScheduleTime] = useState();
  const [contentId, setContentId] = useState();
  const [campaignId, setCampaignId] = useState();
  const [filteredCampaigns, setFilteredCampaigns] = useState(
    getUploadedUGCContentForInfluencerData
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [publishLoading, setPublishLoading] = useState(false);
  const [selected, setSelected] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [platformFilter, setPlatformFilter] = useState('ALL');

  const [isDownloadPopupOpen, setDownloadPopupOpen] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [downloadContentUrl, setDownloadContentUrl] = useState();

  const [submitVideoIdPopup, setSubmitVideoIdPopup] = useState(false);
  const [videoId, setVideoId] = useState("");
  const [videoIdError, setVideoIdError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showFailurePopup, setShowFailurePopup] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const [selectedPlatform, setSelectedPlatform] = useState(null);

  const errorTimeoutRef = useRef(null);

  const getUserInfoReducerData = useSelector((state) => state.getUserInfoReducer.data);

  // Helpers for platform-aware access/token
  const getHasFullAccessForPlatform = (platform) => {
    const upper = String(platform || '').toUpperCase();
    if (upper === 'INSTAGRAM') {
      const access = getUserInfoReducerData?.channelAccessTypeInstagram;
      const tokenExpired = getUserInfoReducerData?.isInstagramTokenExpire;
      return access === 'FULL_ACCESS' && !Boolean(tokenExpired);
    }
    // Default to YouTube
    const access = getUserInfoReducerData?.channelAccessType;
    const tokenExpired = getUserInfoReducerData?.isTokenExpire;
    return access === 'FULL_ACCESS' && !Boolean(tokenExpired);
  };

  const getPlatformTitle = (platform) => {
    const upper = String(platform || '').toUpperCase();
    return upper === 'INSTAGRAM' ? 'Instagram' : 'YouTube';
  };

  const breadcrumbData = [
    { label: "Home", href: "/" },
    // { label: 'My Campaigns', href: '/brand/campaigns' },
    { label: "Approved Content List", href: "#" },
  ];

  const columns = [
    {
      name: "Campaign",
      selector: (row) => row.campaignName,
      sortable: true,
      style: {
        width: "10rem", // Set a smaller width for this column
      },
    },
    {
      name: "Upload Date",
      selector: (row) => (
        <span className="text-[1.4rem] break-words whitespace-normal w-full">
          {moment.utc(row.uploadedAt.split("+")[0]).local().format("DD-MM-YYYY hh:mm A")}
        </span>
      ),
      // value={moment(formValues?.uploadDuration.split("+")[0]).format("DD-MM-YYYY hh:mm A")}
      sortable: true,
      style: {
        width: "10rem", // Adjust the width as needed
      },
    },
    {
      name: "Platform",
      selector: (row) => (
        <span className="text-[1.4rem] break-words whitespace-normal w-full">
          {row?.platform === 'YOUTUBE' ? 'YouTube' : row?.platform === 'INSTAGRAM' ? 'Instagram' : (row?.platform || '-')}
        </span>
      ),
      style: {
        width: "10rem",
      },
    },
    {
      name: "Status",
      selector: (row) => (
        <span
          className={`inline-block px-3 py-1 rounded-full text-center break-words whitespace-normal w-full ${getStatusStyle(
            row.status
          )}`}
        >
          {sanitizeStatus(row.status)}
        </span>
      ),
      style: {
        width: "10rem",
      },
    },
    {
      name: "Reject Reason",
      selector: (row) => (
        <span className={``}>
          {row.status === "UGC_REJECTED" && row.ugcRejectReason ? row.ugcRejectReason : "-"}
        </span>
      ),
      style: {
        width: "10rem",
      },
    },
    {
      name: "Content",
      selector: (row) => (
        <div>
          <button
            className="bg-[#FF0505CC] text-white text-center rounded-[1rem] py-[0.5rem] px-[2.5rem]"
            onClick={() => {
              const newWindow = window.open('', '_blank');
              dispatch(
                streamVideo(
                  { s3ContentPath: row.contentPath },
                  (status, response, message) => {
                    if (status === 200) {
                      // window.open(
                      //   response,
                      //   "_blank",
                      // );
                      if (newWindow) {
                        newWindow.location.href = response;
                      }
                    } else {
                      if (newWindow) {
                        newWindow.close();
                      }
                    }
                  }
                )
              );
            }}
          >
            Preview
          </button>
        </div>
      ),
      style: {
        width: "10rem", // Set a smaller width for this column
      },
    },
    {
      name: "Action",
      cell: (row) =>
        (row.status == "UGC_APPROVED" || row.status == "ADMIN_REJECT_VIDEO_ID") ? !getHasFullAccessForPlatform(row.platform) ? (
          <div className="flex flex-row flex-wrap wrap justify-center items-center gap-2">
            <button
              className="bg-[#0D9B50] text-white text-center rounded-[1rem] py-[0.4rem] px-[1rem] text-[1.3rem] whitespace-wrap"
              onClick={() => {
                setSelectedPlatform(row.platform);
                setSubmitVideoIdPopup(true);
                setVideoId("");
                setVideoIdError("");
                setIsSubmitting(false);
                setSubmitMessage("");
                setCampaignId(row.campaignId);
                setContentId(row.contentId);
              }}
            >
              {row.status === "ADMIN_REJECT_VIDEO_ID" ? "Re Submit Video ID" : "Submit Video ID"}
            </button>
            <button
              className="bg-[#0D9B50] text-white text-center rounded-[1rem] py-[0.4rem] px-[1rem] text-[1.3rem] whitespace-wrap"
              onClick={() => {
                setSelectedPlatform(row.platform);
                setDownloadPopupOpen(true);
                setCampaignId(row.campaignId);
                setContentId(row.contentId);
              }}
            >
              Download
            </button>
          </div>
        ) : (
          <div className="flex flex-col xl:flex-row justify-center items-center gap-2">
            <button
              className="bg-[#0D9B50] text-white text-center rounded-[1rem] py-[0.4rem] px-[1rem] text-[1.3rem] whitespace-nowrap"
              onClick={() => {
                setSelectedPlatform(row.platform);
                setPopupType("publish");
                setIsPopupOpen(true);
                setPublishTitle("");
                setPublishDescription("");
                setContentId(row.contentId);
              }}
            >
              Publish it
            </button>
            <button
              className="bg-[#0D9B50] text-white text-center rounded-[1rem] py-[0.4rem] px-[1rem] text-[1.3rem] whitespace-nowrap"
              onClick={() => {
                setSelectedPlatform(row.platform);
                setPopupType("schedule");
                setIsPopupOpen(true);
                setPublishTitle("");
                setPublishDescription("");
                setScheduleTime("");
                setContentId(row.contentId);
              }}
            >
              Schedule
            </button>
          </div>
        ) : (row.status == "UGC_REJECTED") ? (
          <button
            className="bg-[#0D9B50] text-white text-center rounded-[1rem] py-[0.5rem] px-[2.5rem]"
            onClick={() => {
              navigate("/influencer/campaigns/ugc-upload", {
                state: {
                  campaign: {
                    campaignType: "UGC",
                    campaignId: row.campaignId,
                    contentId: row.contentId,
                  },
                },
              });
            }}
          >
            Re Upload
          </button>
        ) : (
          <div className="text-[1.6rem] text-center">-</div>
        ),
      ignoreRowClick: true,
      style: {
        width: "10rem", // Adjust width for the Action column
      },
    },
  ];

  const handleDownloadContentForManualUpload = () => {
    setLoadingDownload(true);
    dispatch(
      downloadContentForManualUpload(
        { campaignId: campaignId },
        (status, response, message) => {
          if (status == 200) {
            console.log("response", response);
            setDownloadContentUrl(response);
            setLoadingDownload(false);
          } else {
            setLoadingDownload(false);
            Toast(message, "info");
          }
        }
      )
    );
  };

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768); // 768px is typical tablet breakpoint
    };

    // Set initial value
    checkIfMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);

    // Clean up
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  useEffect(() => {
    if (searchQuery === "") {
      setFilteredCampaigns(getUploadedUGCContentForInfluencerData);
    } else {
      const filtered = getUploadedUGCContentForInfluencerData.filter(
        (campaign) =>
          campaign.campaignName
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          campaign.status.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredCampaigns(filtered);
    }
  }, [searchQuery, getUploadedUGCContentForInfluencerData]);

  const customTableStyles = {
    table: {
      style: {
        position: "relative",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#F1F4F9",
        minHeight: "52px",
        fontWeight: 700,
        borderRadius: "0.4rem",
        minWidth: "50%",
        borderBottom: "none",
        // position: 'fixed',
        top: 0,
      },
      denseStyle: {
        minHeight: "32px",
      },
    },
    rows: {
      style: {
        fontSize: "1.4rem", // Increased text size for rows
        fontWeight: 600,
        color: "#202224",
        borderBottom: "1px solid #EDEFF1",
        minHeight: "70px",
      },
      denseStyle: {
        minHeight: "40px",
      },
    },
    headCells: {
      style: {
        padding: "1rem",
        fontSize: "1.6rem",
        textAlign: "left",
      },
    },
    cells: {
      style: {
        padding: "1.5rem",
      },
    },
  };

  useEffect(() => {
    dispatch(
      getUploadedUGCContentForInfluencer(
        {
          campaignId: 0,
          ...(platformFilter !== 'ALL' && { platform: platformFilter }),
        },
        (status, response, message) => {
          if (status === 200) {
            setGetUploadedUGCContentForInfluencerData(response);
            dispatch(getUploadedUGCContentForInfluencerReset());
          } else if (status) {
            setGetUploadedUGCContentForInfluencerData([]);
            dispatch(getUploadedUGCContentForInfluencerReset());
          }
        }
      )
    );
  }, [platformFilter]);

  useEffect(() => {
    if (downloadContentUrl) {
      const link = document.createElement('a');
      link.href = downloadContentUrl;
      link.target = '_blank';
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setDownloadPopupOpen(false);
      setLoadingDownload(false);
    }
  }, [downloadContentUrl]);

  return (
    <div className="w-full h-full flex flex-col overflow-auto bg-[#F2F3F7]">
      <Breadcrumbs breadcrumbs={breadcrumbData} />

      {/* <h1 className="text-[1.8rem] text-[#534D4D] inter-font font-[600] px-[4rem] py-[2.7rem]">
                Approved Content List
            </h1> */}
            
      <div className="px-[4rem] mt-[2rem] w-full">
        <div className="flex justify-start">
          <select
            className="border-2 border-gray-300 w-[30rem] p-3 pr-14 rounded-md text-[1.4rem] inter-font font-[400] outline-none bg-white"
            value={platformFilter}
            onChange={(e) => setPlatformFilter(e.target.value)}
          >
            <option value="ALL">All</option>
            <option value="YOUTUBE">YouTube</option>
            <option value="INSTAGRAM">Instagram</option>
          </select>
        </div>
      </div>
      <div className="px-[4rem] mt-[2rem] w-full">
        <div className="w-full h-full flex flex-col rounded-[2.6rem] bg-[#ffffff]">
          <div className="sticky top-0 z-10 bg-[#ffffff] p-[2.8rem]">
            <h1 className="text-[2.4rem] inter-font font-[700]">
              Content List
            </h1>
          </div>

          <div className="w-full max-h-[50rem] overflow-y-auto no-scrollbar px-[2.4rem] pb-[2.4rem]">
            {Array.isArray(filteredCampaigns) && filteredCampaigns.length > 0 ? (
              isMobile ? (
                // Mobile view - Cards
                <div className="flex flex-col space-y-4">
                  {filteredCampaigns.map((content, index) => (
                    <ContentCard
                      key={index}
                      content={content}
                      hasFullAccess={getHasFullAccessForPlatform(content.platform)}
                      platformTitle={getPlatformTitle(content.platform)}
                      onPreview={(content) => {
                        const newWindow = window.open('', '_blank');
                        dispatch(
                          streamVideo(
                            { s3ContentPath: content.contentPath },
                            (status, response, message) => {
                              if (status === 200) {
                                if (newWindow) {
                                  newWindow.location.href = response;
                                }
                              } else {
                                if (newWindow) {
                                  newWindow.close();
                                }
                              }
                            }
                          )
                        );
                      }}
                      onPublish={(content) => {
                        setSelectedPlatform(content.platform);
                        setPopupType("publish");
                        setIsPopupOpen(true);
                        setPublishTitle("");
                        setPublishDescription("");
                        setContentId(content.contentId);
                      }}
                      onSchedule={(content) => {
                        setSelectedPlatform(content.platform);
                        setPopupType("schedule");
                        setIsPopupOpen(true);
                        setPublishTitle("");
                        setPublishDescription("");
                        setScheduleTime("");
                        setContentId(content.contentId);
                      }}
                      onSubmitVideoId={(content) => {
                        setSelectedPlatform(content.platform);
                        setSubmitVideoIdPopup(true);
                        setVideoId("");
                        setVideoIdError("");
                        setIsSubmitting(false);
                        setSubmitMessage("");
                        setCampaignId(content.campaignId);
                        setContentId(content.contentId);
                      }}
                      onDownload={(content) => {
                        setSelectedPlatform(content.platform);
                        setDownloadPopupOpen(true);
                        setCampaignId(content.campaignId);
                        setContentId(content.contentId);
                      }}
                      onReUpload={(content) => {
                        navigate("/influencer/campaigns/ugc-upload", {
                          state: {
                            campaign: {
                              campaignType: "UGC",
                              campaignId: content.campaignId,
                              contentId: content.contentId,
                            },
                          },
                        });
                      }}
                    />
                  ))}
                </div>
              ) : (
                // Desktop view - Table
                <DataTable
                  columns={columns}
                  data={filteredCampaigns}
                  customStyles={customTableStyles}
                  pagination
                  highlightOnHover
                  striped
                  responsive
                />
              )
            ) : (
              <div className="text-4xl leading-[70px] text-gray-500 text-center mt-4">
                There are no records to display.
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />

      {/* Conditional Popup */}
      <Popup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        title={popupType === "publish" ? "Publish It" : "Schedule It"}
        canDismiss
        content={
          <div className="text-[1.6rem] mt-12">
            <form className="space-y-4">
              <div>
                <label htmlFor="title" className="text-[#202224] text-[1.5rem]">
                  Add Title<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="title"
                  value={publishTitle}
                  placeholder="Enter Title here"
                  className="w-full bg-[#F7FBFF] h-20 border border-gray-300 rounded-2xl px-4 py-2 focus:outline-none"
                  onChange={(e) => {
                    setPublishTitle(e.target.value);
                  }}
                />
              </div>
              <div>
                <label
                  htmlFor="description"
                  className="text-[#202224] text-[1.5rem]"
                >
                  Add Description<span className="text-red-500">*</span>
                </label>
                <input
                  id="description"
                  placeholder="Enter Description here"
                  value={publishDescription}
                  className="w-full bg-[#F7FBFF] h-20 border border-gray-300 rounded-2xl px-4 py-2 focus:outline-none"
                  onChange={(e) => {
                    setPublishDescription(e.target.value);
                  }}
                />
              </div>
              {String(selectedPlatform || '').toUpperCase() !== 'INSTAGRAM' && (
                <div className="flex flex-col">
                  <label className=" ">
                    <input
                      type="radio"
                      name="booleanOption"
                      checked={selected === true}
                      onChange={() => setSelected(true)}
                      className="w-5 h-5 "
                    />
                    <span className="text-[#202224] text-[1.5rem] ml-3">
                      Yes, it's made for kids
                    </span>
                  </label>

                  <label className=" mt-2 ">
                    <input
                      type="radio"
                      name="booleanOption"
                      checked={selected === false}
                      onChange={() => setSelected(false)}
                      className="w-5 h-5 "
                    />
                    <span className="text-[#202224] text-[1.5rem] ml-3">
                      No, it's not made for kids
                    </span>
                  </label>
                </div>
              )}

              {popupType === "schedule" && (
                <div className="relative w-full " >
                  <label htmlFor="datetime" className="text-[#202224] text-[1.5rem]">
                    Add Schedule<span className="text-red-500">*</span>
                  </label>
                  <div className="w-full bg-[#F7FBFF]  border border-gray-300 rounded-2xl">
                    <input
                      type="datetime-local"
                      id="datetime"
                      min={new Date().toISOString().slice(0, 16)}
                      placeholder="Enter Schedule here"
                      className="w-full h-20 bg-[#F7FBFF] px-4 py-2 focus:outline-none"
                      value={scheduleTime}
                      onChange={(e) => {
                        const selectedTime = new Date(e.target.value);
                        if (isPastDate(selectedTime)) {
                          console.log("Selected date is in the past!");
                        } else {
                          setScheduleTime(e.target.value);
                        }
                      }}
                    />
                    <img
                      src={MyCampaignsImg.calendarIcon}
                      alt="Calendar Icon"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 mt-4 w-10 h-10"
                      onKeyDown={(e) => e.preventDefault()}
                      onClick={() => {
                        const inputDateElement =
                          document.getElementById("datetime");
                        inputDateElement.showPicker();
                      }}
                    />
                  </div>
                </div>
              )}
            </form>
          </div>
        }
        size="sm"
        primaryButton={{
          text: publishLoading ? (
            <div className="flex items-center justify-center">
              <Oval
                visible={true}
                height="25"
                width="25"
                color="#000000"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : popupType === "publish" ? (
            "Upload Now"
          ) : (
            "Schedule Now"
          ),
          onClick: () => {
            if (popupType === "publish") {
              if (!publishTitle?.trim()) {
                Toast("Title is mandatory", "error");
              } else if (!publishDescription?.trim()) {
                Toast("Description is mandatory", "error");
              } else {
                setPublishLoading(true);
                dispatch(
                  publishVideoOnYoutube(
                    {
                      contentId: contentId,
                      title: publishTitle,
                      description: publishDescription,
                      isPublishNow: true,
                      scheduleDateTime: "",
                      madeForKids: selected,
                    },
                    (status, response, message) => {
                      if (status == 200) {
                        Toast(message, "success");
                        // setPublishVideoResponse({ status: 200, response: response, message: message });
                        // setSuccessPopupOpen(true);
                        setPublishLoading(false);
                        dispatch(
                          getUploadedUGCContentForInfluencer(
                            {
                              campaignId: 0,
                              ...(platformFilter !== 'ALL' && { platform: platformFilter }),
                            },
                            (status, response, message) => {
                              if (status === 200) {
                                setGetUploadedUGCContentForInfluencerData(
                                  response
                                );
                                dispatch(
                                  getUploadedUGCContentForInfluencerReset()
                                );
                              } else if (status) {
                                dispatch(
                                  getUploadedUGCContentForInfluencerReset()
                                );
                              }
                            }
                          )
                        );
                        setIsPopupOpen(false);
                      } else if (status === 305) {
                        Toast(message, "error");
                        setPublishLoading(false);
                        setIsPopupOpen(false);
                        // setPopupForTokenExpireOpen(true)
                      } else if (status) {
                        Toast(message, "error");
                        setPublishLoading(false);
                        setIsPopupOpen(false);
                        // setPublishVideoResponse({ status: status, response: response, message: message });
                        // setSuccessPopupOpen(true);
                      }
                    }
                  )
                );
              }
            } else {
              if (!publishTitle?.trim()) {
                Toast("Title is mandatory", "error");
              } else if (!publishDescription?.trim()) {
                Toast("Description is mandatory", "error");
              } else if (!scheduleTime) {
                Toast("Date is mandatory", "error");
              } else {
                setPublishLoading(true);
                dispatch(
                  publishVideoOnYoutube(
                    {
                      contentId: contentId,
                      title: publishTitle,
                      description: publishDescription,
                      isPublishNow: false,
                      scheduleDateTime: moment(scheduleTime).format(
                        "YYYY-MM-DD HH:mm:ss"
                      ),
                      madeForKids: selected,
                    },
                    (status, response, message) => {
                      if (status == 200) {
                        Toast(message, "success");
                        // setPublishVideoResponse({ status: 200, response: response, message: message });
                        // setSuccessPopupOpen(true);
                        setPublishLoading(false);
                        dispatch(
                          getUploadedUGCContentForInfluencer(
                            {
                              campaignId: 0,
                              ...(platformFilter !== 'ALL' && { platform: platformFilter }),
                            },
                            (status, response, message) => {
                              if (status === 200) {
                                setGetUploadedUGCContentForInfluencerData(
                                  response
                                );
                                dispatch(
                                  getUploadedUGCContentForInfluencerReset()
                                );
                              } else if (status) {
                                dispatch(
                                  getUploadedUGCContentForInfluencerReset()
                                );
                              }
                            }
                          )
                        );
                        setIsPopupOpen(false);
                      } else if (status) {
                        Toast(message, "error");
                        setPublishLoading(false);
                        setIsPopupOpen(false);
                        // setPublishVideoResponse({ status: status, response: response, message: message });
                        // setSuccessPopupOpen(true);
                      }
                    }
                  )
                );
              }
            }
          },
        }}
      />
      <Popup
        isOpen={isDownloadPopupOpen}
        onClose={() => setDownloadPopupOpen(false)}
        title="Download Content"
        canDismiss
        icon={<TbClockPlay color="#0D9B50" size={110} className="my-[5rem]" />}
        content={
          <p className="text-[1.6rem] w-[80%] mx-auto text-center">
            {`Submit ${getPlatformTitle(selectedPlatform)} Video ID within 24 hours of download or you'll be removed from campaign`}
          </p>
        }
        size="sm"
        primaryButton={{
          text: loadingDownload ? (
            <div className="flex justify-center items-center">
              <Oval visible={true} height="25" width="25" color="#000000" ariaLabel="oval-loading" />
            </div>
          ) : (
            "Ok"
          ),
          onClick: () => {
            if (!loadingDownload) {
              handleDownloadContentForManualUpload();
            }
          }
        }}
      />
      <Popup
        isOpen={submitVideoIdPopup}
        onClose={() => setSubmitVideoIdPopup(false)}
        title={`${getPlatformTitle(selectedPlatform)} Video ID`}
        icon={<BsCollectionPlayFill color="#16a34a" size={80} className="my-4" />}
        content={
          <div>
            <input
              type="text"
              value={videoId}
              onChange={(e) => {
                setVideoId(e.target.value);
                if (videoIdError) {
                  setVideoIdError("");
                }
              }}
              placeholder={`Enter ${getPlatformTitle(selectedPlatform)} Video ID`}
              className="w-full h-[4.8rem] border border-gray-300 rounded-md p-4 text-start text-[1.6rem] focus:outline-none focus:ring focus:ring-green-400"
            />
            {videoIdError && <p className="text-red-500 text-[1.4rem] mt-2">{videoIdError}</p>}
          </div>
        }
        size="sm"
        primaryButton={{
          text: isSubmitting ? "Submitting..." : "Submit",
          onClick: () => {
            if (!videoId.trim()) {
              setVideoIdError("Please enter a Video ID");
              errorTimeoutRef.current = setTimeout(() => setVideoIdError(""), 5000);
              return;
            }
            setIsSubmitting(true);
            const payload = {
              campaignId: campaignId,
              videoId: videoId,
            };
            dispatch(
              optAndSubmitContentLink(payload, (status, response, message) => {
                setIsSubmitting(false);
                setSubmitMessage(message);
                setSubmitVideoIdPopup(false);
                if (status === 200) {
                  setShowSuccessPopup(true);
                  setVideoId("");
                } else {
                  setShowFailurePopup(true);
                }
              })
            );
          },
          className: "bg-[#16a34a] hover:bg-[#15803d]",
          disabled: isSubmitting,
        }}
        secondaryButton={{
          text: "Cancel",
          onClick: () => setSubmitVideoIdPopup(false),
          className: "bg-gray-200 text-gray-800 hover:bg-gray-300",
        }}
      />
      {showSuccessPopup && (
        <Popup
          isOpen={showSuccessPopup}
          onClose={() => setShowSuccessPopup(false)}
          icon={<IoIosCheckmarkCircle color="#16a34a" size={80} className="my-4" />}
          content={
            <p className="text-center text-[1.6rem] text-gray-600">
              {submitMessage}
            </p>
          }
          size="sm"
          primaryButton={{
            text: "Done",
            onClick: () => {setShowSuccessPopup(false); navigate("/influencer/campaigns");},
            className: "bg-[#16a34a] hover:bg-[#15803d]",
          }}
        />
      )}
      {showFailurePopup && (
        <Popup
          isOpen={showFailurePopup}
          onClose={() => setShowFailurePopup(false)}
          icon={<IoIosCloseCircle color="#ef4444" size={80} className="my-4" />}
          content={
            <p className="text-center text-[1.6rem] text-gray-600">
              {submitMessage ? submitMessage : "Error: Unable to validate your video ID at the moment. Please try again later"}
            </p>
          }
          size="sm"
          primaryButton={{
            text: "Try Again",
            onClick: () => {
              setVideoIdError("");
              setVideoId("");
              setShowFailurePopup(false);
              setSubmitVideoIdPopup(true);
            },
            className: "bg-[#ef4444] hover:bg-[#dc2626]",
          }}
          secondaryButton={{
            text: "Cancel",
            onClick: () => setShowFailurePopup(false),
            className: "bg-gray-200 text-gray-800 hover:bg-gray-300",
          }}
        />
      )}
    </div>
  );
};

export default ApprovedList;
